import { getAuthToken } from "../api";

export async function saveProctoringSignals(interviewId, payload) {
  if (!interviewId) {
    return;
  }

  const token = await getAuthToken();
  const response = await fetch(
    `${process.env.REACT_APP_API_BASE || "http://localhost:8000"}/invite/interviews/${interviewId}/proctoring`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      },
      body: JSON.stringify(payload)
    }
  );

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || "Unable to save proctoring signals");
  }
}
